import './overflowMenuIntercom.scss';

export const OverflowMenuIntercomComponentModule = angular
    .module('app.components.pageHeader.overflowMenuIntercom', [])
    .component('overflowMenuIntercom', {
        template: `
            <md-menu-item class="overflow-menu-intercom">
                <intercom-button>
                    <span class="overflow-menu-intercom__text" translate="HELP_ACTIONS.CHAT"></span>
                    <intercom-unread-count></intercom-unread-count>
                </intercom-button>
            </md-menu-item>
        `
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/pageHeader/overflowMenu/overflowMenuIntercom.js